import useGlobalConfig from "@/store/global";

const Cutaquig = () => {
  const { themeColor } = useGlobalConfig();

  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <div className="my-6 border-b-2 border-dotted" 
          style={{ borderColor: themeColor }} />

        <div className="font-bold text-base">
          Indications and Important Safety Information For CUTAQUIG® (Immune Globulin Subcutaneous (Human) - hipp)
        </div>

        <div className="mt-6 px-4 py-2 border border-black">
          <p className="font-bold">WARNING: THROMBOSIS</p>
          
          <p className="mt-2">
            Please see Full Prescribing Information for complete BOXED WARNING.
          </p>

          <ul className="list-disc ml-4 mt-4 font-bold">
            <li className="my-2">
              Thrombosis may occur with immune globulin products, including cutaquig. Risk factors may include: advanced age, prolonged immobilization, hypercoagulable conditions, history of venous or arterial thrombosis, use of estrogens, indwelling central vascular catheters, hyperviscosity, and cardiovascular risk factors. Thrombosis may occur in the absence of known risk factors. [see Full Prescription Information, Warning and Precautions (5.2), Patient Counseling Information (17)]
            </li>
            <li className="my-2">
              For patients at risk of thrombosis, administer cutaquig at the minimum dose and infusion rate practicable. Ensure adequate hydration in patients before administration. Monitor for signs and symptoms of thrombosis and assess blood viscosity in patients at risk of hyperviscosity. [see Full Prescribing Information, Warnings and Precautions (5.2)]
            </li>
          </ul>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Indications and Usage</p>
          <p className="my-2">
            Cutaquig (Immune Globulin Subcutaneous [Human] - hipp) is a 16.5% immune globulin solution for subcutaneous infusion (IGSC), indicated as replacement therapy for primary humoral immunodeficiency (PI) in adults and pediatric patients 2 years of age and older. This includes, but is not limited to, common variable immunodeficiency (CVID), X-linked agammaglobulinemia, congenital agammaglobulinemia, Wiskott-Aldrich syndrome, and severe combined immunodeficiencies.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Contraindications</p>
          <p className="my-2">
            Cutaquig is contraindicated in patients who have had an anaphylactic or severe systemic reaction to the subcutaneous administration of human immune globulin or to any of the components of cutaquig, such as Polysorbate 80, and in IgA-deficient patients with antibodies against IgA and a history of hypersensitivity.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Warnings and Precautions</p>
          <ul className="">
            <li className="my-2">Severe hypersensitivity reactions may occur with cutaquig, even in patients who tolerated previous treatment with human immune globulin. If a hypersensitivity reaction occurs, discontinue the cutaquig infusion immediately and initiate appropriate treatment. IgA-deficient patients with anti-IgA antibodies are at greater risk of severe reactions.</li>
            <li className="my-2">Thrombosis may occur following treatment with immune globulin products, including cutaquig. For patients at risk of thrombosis, administer cutaquig at the minimum dose and infusion rate practicable. Ensure adequate hydration in patients before administration. Monitor for signs and symptoms of thrombosis and assess blood viscosity in patients at risk for hyperviscosity.</li>
            <li className="my-2">Falsely elevated blood glucose readings may occur during and after the infusion of cutaquig with some glucometer and test strip systems. When administering cutaquig, measure blood glucose with a glucose-specific method.</li>
            <li className="my-2">Aseptic meningitis syndrome (AMS) can occur with cutaquig. AMS has been reported after the use of human immune globulin administered intravenously and subcutaneously and may occur within 2 days following treatment. Discontinuation of immunoglobulin treatment has resulted in remission within several days without sequelae.</li>
            <li className="my-2">Acute renal dysfunction/failure, acute tubular necrosis, proximal tubular nephropathy, osmotic nephrosis, and death may occur with use of human immune globulin, especially those containing sucrose. Cutaquig does not contain sucrose.</li>
            <li className="my-2">Monitor patients for signs and symptoms of renal dysfunction. Monitor blood urea nitrogen, serum creatinine, and urine output in patients at risk of acute renal failure.</li>
            <li className="my-2">Monitor cutaquig recipients for clinical signs and symptoms of hemolysis, particularly patients with pre-existing anemia and/or cardiovascular or pulmonary compromise. Consider appropriate confirmatory laboratory testing if signs and symptoms of hemolysis are present after cutaquig infusion.</li>
            <li className="my-2">Non-cardiogenic pulmonary edema may occur in patients administered human immune globulin products. Monitor for pulmonary adverse reactions (transfusion-related acute lung injury, TRALI).</li>
            <li className="my-2">Cutaquig is made from human plasma and may carry a risk of transmitting infectious agents, e.g., viruses, the variant Creutzfeldt-Jakob disease agent, and, theoretically, the Creutzfeldt-Jakob disease agent.</li>
          </ul>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Drug Interactions</p>
          <p className="my-2">
            After infusion of cutaquig, the transitory rise of the various passively transferred antibodies in the patient's blood may yield false positive serological test results, with the potential for misleading interpretation.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Adverse Reactions</p>
          <p className="my-2">
            The most common adverse reactions (≥5% of study subjects) were local infusion site reactions (such as redness, swelling, itching), headache, fever, dermatitis, asthma, diarrhea, and cough.
          </p>
          <p className="my-2">
            The passive transfer of antibodies with immunoglobulin administration may interfere with the response to live virus vaccines such as measles, mumps, rubella, and varicella.
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">
            <a
              target="_blank"
              href="/cutaquig-full-prescribing-information.pdf"
              className="!text-sky-700 hover:underline"
              rel="noopener noreferrer"
            >
              Please click here for Full Prescribing Information.
            </a>
          </p>
        </div>

      </div>
    </>
  );
};

export default Cutaquig;
